import { render, staticRenderFns } from "./GenericControl.vue?vue&type=template&id=0fe84da0&scoped=true&"
import script from "./GenericControl.vue?vue&type=script&lang=ts&"
export * from "./GenericControl.vue?vue&type=script&lang=ts&"
import style0 from "./GenericControl.vue?vue&type=style&index=0&id=0fe84da0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe84da0",
  null
  
)

export default component.exports